/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeagueMatchCheck = {
    properties: {
        matchDay: {
            type: 'number',
            isRequired: true,
        },
        team1: {
            type: 'string',
            isRequired: true,
        },
        team2: {
            type: 'string',
            isRequired: true,
        },
        startTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        leagueId: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
